import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { IoChevronBack } from 'react-icons/io5';
import { useAuth } from '../../context/AuthContext';
import { db } from '../../firebase/config';
import { doc, updateDoc } from 'firebase/firestore';

const NOTIFICATION_ITEMS = [
  { key: 'board', label: '수업 게시판 등록' },
  { key: 'material', label: '수업자료 등록' },
  { key: 'video', label: '수업영상 등록' },
  { key: 'assignment', label: '새 수업과제 등록' },
  { key: 'assignmentDeadline', label: '과제 마감 알림' },
  { key: 'exam', label: '시험 일정 알림' },
  { key: 'grade', label: '성적 등록' },
  { key: 'adminMessage', label: '관리자 공지 메시지' },
];

const NotificationSettingsPage = () => {
  const navigate = useNavigate();
  const { userData } = useAuth();
  const [settings, setSettings] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!userData) return;
    const saved = userData.notificationSettings || {};
    const initial = {};
    NOTIFICATION_ITEMS.forEach(item => {
      initial[item.key] = saved[item.key] !== undefined ? saved[item.key] : true;
    });
    setSettings(initial);
  }, [userData]);

  const handleToggle = async (key) => {
    const updated = { ...settings, [key]: !settings[key] };
    setSettings(updated);
    if (!userData?.uid) return;
    setSaving(true);
    try {
      await updateDoc(doc(db, 'users', userData.uid), {
        notificationSettings: updated,
      });
    } catch (err) {
      console.error('알림 설정 저장 실패:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)}><IoChevronBack size={24} /></BackBtn>
        <Title>알림 설정</Title>
      </Header>
      <Content>
        <Desc>받고 싶은 알림을 선택하세요.</Desc>
        <List>
          {NOTIFICATION_ITEMS.map(item => (
            <Row key={item.key} onClick={() => handleToggle(item.key)}>
              <RowLabel>{item.label}</RowLabel>
              <Toggle $on={!!settings[item.key]}>
                <ToggleCircle $on={!!settings[item.key]} />
              </Toggle>
            </Row>
          ))}
        </List>
      </Content>
    </Container>
  );
};

export default NotificationSettingsPage;

const Container = styled.div`
  background: ${({ theme }) => theme.colors.background.default};
  min-height: 100vh;
  padding-bottom: 80px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid #E5E7EB;
  background: white;
`;

const BackBtn = styled.button`
  color: #111;
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: 600;
`;

const Content = styled.div`
  padding: 16px;
`;

const Desc = styled.p`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 16px;
`;

const List = styled.div`
  background: white;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  cursor: pointer;
  border-bottom: 1px solid #F3F4F6;
  &:last-child { border-bottom: none; }
`;

const RowLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Toggle = styled.div`
  width: 44px;
  height: 24px;
  border-radius: 12px;
  background: ${({ $on }) => $on ? 'var(--color-primary)' : '#D1D5DB'};
  position: relative;
  transition: background 0.2s;
`;

const ToggleCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  position: absolute;
  top: 2px;
  left: ${({ $on }) => $on ? '22px' : '2px'};
  transition: left 0.2s;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
`;
